import { render } from "./painting-4.vue?vue&type=template&id=d288478a&scoped=true"
import script from "./painting-4.vue?vue&type=script&lang=js"
export * from "./painting-4.vue?vue&type=script&lang=js"

import "./painting-4.vue?vue&type=style&index=0&id=d288478a&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d288478a"]])

export default __exports__